<!-- <h1 class="st-modal-header" mat-dialog-title>{{title}}</h1> -->
<div class="st-modal-header">
    <mat-icon class="material-icons-outlined">error_outline</mat-icon>
    <div class="st-modal-header-title">{{ title }}</div>
</div>
<div class="st-modal-body">
    {{content}}
</div>
<div class="st-modal-footer">
    <button mat-button
            class="st-modal-button-no"
            (click)="onNoClick()">
        {{no}}
    </button>
    <button mat-button
            class="st-modal-button-yes"
            (click)="onYesClick()"
            cdkInitialFocus>
        {{yes}}
    </button>
</div>